import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, AlertOctagon, AlertTriangle, Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const PRIO_ICON = { Critical: AlertOctagon, Warning: AlertTriangle, Info: Info };
const PRIO_COLOR = { Critical: "text-rose-500", Warning: "text-amber-500", Info: "text-sky-500" };

export default function StockAlerts() {
  const [items, setItems] = useState([]);
  const [summary, setSummary] = useState({ total: 0, critical: 0, warning: 0 });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/alerts").then((r) => setItems(r.data.filter((a) => a.status !== "Selesai"))).catch(() => {});
    api.get("/alerts/summary").then((r) => setSummary(r.data)).catch(() => {});
  }, [location.pathname]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative rounded-lg p-2 text-slate-500 hover:bg-slate-100" data-testid="notif-btn" aria-label="Pusat notifikasi">
          <Bell className="h-5 w-5" />
          {summary.total > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white" data-testid="notif-badge">
              {summary.total > 99 ? "99+" : summary.total}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="notif-dropdown">
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <p className="font-display text-sm font-semibold text-slate-800">Pusat Notifikasi</p>
          <span className="text-xs text-slate-400">{summary.critical} kritis · {summary.warning} peringatan</span>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-slate-400" data-testid="notif-empty">Semua kondisi aman.</p>
          ) : items.slice(0, 12).map((a) => {
            const Icon = PRIO_ICON[a.priority] || Info;
            return (
              <button key={a.key} onClick={() => navigate(a.link)} className="flex w-full items-start gap-3 px-4 py-2.5 text-left hover:bg-slate-50" data-testid={`notif-item-${a.key}`}>
                <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${PRIO_COLOR[a.priority] || "text-slate-400"}`} />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-xs font-semibold text-slate-800">{a.jenis}</p>
                  <p className="text-[11px] text-indigo-500">{a.module}</p>
                  <p className="truncate text-[11px] text-slate-400">{a.description}</p>
                </div>
              </button>
            );
          })}
        </div>
        <button onClick={() => navigate("/notifications")} className="w-full border-t border-slate-100 py-2.5 text-center text-xs font-semibold text-indigo-600 hover:bg-slate-50" data-testid="notif-view-all">
          Lihat Semua Notifikasi
        </button>
      </PopoverContent>
    </Popover>
  );
}
